import { cn } from '@/app/utils'
import SvgLoader from '@/assets/svg/Loader.svg'

import styles from './Loader.module.css'
import { LoaderVariants } from './Loader.types'

type Props = {
  className?: string
  noText?: boolean
  variant?: LoaderVariants
}

const Loader = ({ className, noText, variant = 'default' }: Props) => (
  <div
    className={cn('flex flex-col items-center', className)}
    data-testid="app-loader-id"
  >
    <span
      className={cn('animate-spin', styles[variant])}
      data-testid="app-loader-spinner-id"
    >
      <SvgLoader />
    </span>
    {!noText && (
      <p className="mt-8 text-grey-50 text-14" data-testid="app-loader-text-id">
        Загружается...
      </p>
    )}
  </div>
)

export default Loader
